var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.883,
    height: 13,
    viewBox: "0 0 10.883 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75558",
    "data-name": "Group 75558",
    transform: "translate(1732.571 -1473.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71102",
    "data-name": "Path 71102",
    d: "M-1728.619,1482a.658.658,0,0,0,.464.2.656.656,0,0,0,.461-.2l3.442-3.494a.668.668,0,0,0-.01-.943.649.649,0,0,0-.916.01l-2.977,3.022-.828-.84a.65.65,0,0,0-.917.01.666.666,0,0,0,0,.933Z",
    transform: "translate(-0.056 -0.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71103",
    "data-name": "Path 71103",
    d: "M-1721.8,1475.426a.6.6,0,0,0-.286-.235l-4.812-1.955a.628.628,0,0,0-.469,0l-4.809,1.954a.625.625,0,0,0-.289.236.651.651,0,0,0-.108.355v3.665c0,3.71,4.9,6.53,5.132,6.659a.632.632,0,0,0,.314.087.655.655,0,0,0,.324-.093c.854-.5,5.112-3.174,5.112-6.653v-3.665A.622.622,0,0,0-1721.8,1475.426Zm-1.147.786v3.233c0,2.526-3.325,4.818-4.185,5.368-1.081-.691-4.187-2.894-4.187-5.368v-3.233l4.187-1.7Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldVerified);
export default __webpack_public_path__ + "static/media/bold_verified.03d150f34e95e1f5e1529d52ccc5d580.svg";
export { ForwardRef as ReactComponent };